import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("cookie_consent")) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
  };

  const handleRefuse = () => {
    localStorage.setItem("cookie_consent", "refused");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 shadow-lg">
      <div className="max-w-5xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
          <p className="text-sm text-slate-600">
            Ce site utilise des cookies fonctionnels pour assurer son bon fonctionnement.
            En savoir plus dans notre{" "}
            <Link to="/politique-confidentialite" className="text-blue-600 underline hover:text-blue-700">
              politique de confidentialit&eacute;
            </Link>.
          </p>
        </div>
        <div className="flex gap-2 flex-shrink-0">
          <Button
            variant="outline"
            size="sm"
            onClick={handleRefuse}
            className="rounded-full text-slate-600 border-slate-300 hover:bg-slate-50"
          >
            Refuser
          </Button>
          <Button
            size="sm"
            onClick={handleAccept}
            className="rounded-full bg-blue-600 hover:bg-blue-700 text-white"
          >
            Accepter
          </Button>
        </div>
      </div>
    </div>
  );
}
